<template>
  <div class="party-building-container">
    <!-- 顶部横幅区域，可替换成医院党建相关实拍图 -->
    <div class="banner">
      <img
        
        src="../../assets/yyimages/djrw.png"
        alt="党建横幅"
        class="banner-img"
      />
    </div>

    <!-- 标题与引言 -->
    <div class="title-section">
      <h1>党建引领，人文筑院</h1>
      <p>湖南省芦淞区中医骨伤专科医院以党建为魂，践行人文医疗，守护群众健康</p>
    </div>

    <!-- 党建引领板块 -->
    <div class="content-section">
      <h2>一、党建引领发展</h2>
      <div class="content-item">
        <!-- <img
          src="https://picsum.photos/400/300?random=2"
          alt="党建活动"
          class="content-img"
        /> -->
        <div class="text-box">
          <p>医院党支部强化政治引领，深入学习贯彻党的卫生健康政策，将党建工作与医疗业务深度融合。通过开展“党建+医疗质量提升”“党建+服务创新”等行动，引领全体医护人员坚守初心使命，为患者提供更优质的骨伤诊疗服务。</p>
          <p>定期组织党建学习活动、主题党日，加强党员思想建设，发挥党员先锋模范作用，让党旗在临床一线高高飘扬。</p>
        </div>
      </div>
    </div>

    <!-- 人文关怀板块 -->
    <div class="content-section">
      <h2>二、人文关怀暖人心</h2>
      <div class="content-item reverse">
        <!-- <img
          src="https://picsum.photos/400/300?random=3"
          alt="人文服务"
          class="content-img"
        /> -->
        <div class="text-box">
          <p>以“大医精诚”为指引，医院将人文关怀融入诊疗全程。从温馨舒适的就医环境打造，到医护人员耐心细致的问诊、治疗，处处体现对患者的尊重与关爱。</p>
          <p>针对骨伤患者康复周期长的特点，开展康复关怀行动，医护人员主动为患者提供康复指导、心理疏导，让患者在治疗中感受温暖与希望，助力患者重拾健康生活信心。</p>
        </div>
      </div>
    </div>

    <!-- 党建人文融合实践板块 -->
    <div class="content-section">
      <h2>三、党建人文融合实践</h2>
      <div class="content-item">
        <!-- <img
          src="https://picsum.photos/400/300?random=4"
          alt="融合实践"
          class="content-img"
        /> -->
        <div class="text-box">
          <p>医院积极开展“党建+公益义诊”活动，党员医护带头走进社区、乡村，为群众免费进行骨伤筛查、健康科普，传递健康关怀。同时，打造“党员示范岗”，以优质服务树立标杆，带动全院提升服务水平，用实际行动诠释党建人文理念，为守护区域群众骨伤健康贡献力量。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PartyBuildingHumanity'
}
</script>

<style scoped>
/* 整体容器，白底、居中、设置最大宽度和内边距等 */
.party-building-container {
  width: 80%;
  max-width: 1200px;
  margin: 0 auto;
  background-color: #fff;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  opacity: 0;
  transform: translateY(20px);
  animation: fadeInUp 0.8s ease-out forwards;
}

/* 横幅图片样式，宽度铺满，高度自适应 */
.banner-img {
  width: 100%;
  height: 560px;
  border-radius: 8px;
}

/* 标题区域样式，文字居中，增加间距 */
.title-section {
  text-align: center;
  margin: 30px 0;
}
.title-section h1 {
  color: #007bff;
  margin-bottom: 10px;
}
.title-section p {
  color: #666;
}

/* 内容板块通用样式，设置标题样式和间距 */
.content-section {
  margin-bottom: 40px;
}
.content-section h2 {
  color: #333;
  border-left: 5px solid #007bff;
  padding-left: 10px;
  margin-bottom: 20px;
}

/* 内容项布局，图片和文字并排，不同方向排版 */
.content-item {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
}
.reverse {
  flex-direction: row-reverse;
}
.content-img {
  width: 40%;
  height: auto;
  border-radius: 8px;
  transition: transform 0.3s ease;
}
.content-img:hover {
  transform: scale(1.05);
}

/* 文字盒子样式，设置行高、颜色等 */
.text-box {
  flex: 1;
  line-height: 1.6;
  color: #555;
}

/* 入场动画，让页面渐显并上移 */
@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>